var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRsvp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D5C90EAE-D422-451D-9E30-9572AE2AD39C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-3-Copy-18",
    transform: "translate(-1039.000000, -1538.000000)",
    fill: "#FF5043",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar-(3)",
    transform: "translate(1039.000000, 1538.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.20308175,17 L13.7969183,17 C15.0123,17 16,15.9894359 16,14.7459194 L16,3.51331651 C16,2.26980004 15.0123,1.25923589 13.7969183,1.25923589 L12.9230848,1.25923589 L12.9230848,0.629617947 C12.9230848,0.283317561 12.646126,0 12.3076607,0 C11.9691954,0 11.6922879,0.283317561 11.6922879,0.629617947 L11.6922879,1.25923589 L4.30771207,1.25923589 L4.30771207,0.629617947 C4.30771207,0.283317561 4.03075322,0 3.69228793,0 C3.35382264,0 3.07691517,0.283317561 3.07691517,0.629617947 L3.07691517,1.25923589 L2.20308175,1.25923589 C0.987699996,1.25923589 0,2.26980004 0,3.51331651 L0,14.7459194 C0,15.9894359 0.987699996,17 2.20308175,17 Z M1.2307969,3.51331651 C1.2307969,2.96555521 1.66771361,2.51852436 2.20308175,2.51852436 L3.07691517,2.51852436 L3.07691517,3.14814231 C3.07691517,3.49444269 3.35382264,3.77776025 3.69228793,3.77776025 C4.03075322,3.77776025 4.30766069,3.49444269 4.30766069,3.14814231 L4.30766069,2.51852436 L11.6922879,2.51852436 L11.6922879,3.14814231 C11.6922879,3.49444269 11.9691954,3.77776025 12.3076607,3.77776025 C12.646126,3.77776025 12.9230334,3.49444269 12.9230334,3.14814231 L12.9230334,2.51852436 L13.7968669,2.51852436 C14.332235,2.51852436 14.7691517,2.96555521 14.7691517,3.51331651 L14.7691517,5.35185769 L1.2307969,5.35185769 L1.2307969,3.51331651 Z M1.2307969,6.61109359 L14.7692545,6.61109359 L14.7692545,14.7459194 C14.7692545,15.2936807 14.3323378,15.7407115 13.7969696,15.7407115 L2.20308175,15.7407115 C1.66771361,15.7407115 1.2307969,15.2936807 1.2307969,14.7459194 L1.2307969,6.61109359 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsvp);
export default __webpack_public_path__ + "static/media/rsvp.655bd2adcd001829c736e22042b69bec.svg";
export { ForwardRef as ReactComponent };